import { Schema } from "effect"
import { HttpApi, HttpApiEndpoint, HttpApiGroup, OpenApi } from "effect/http-api"
import { AccountsApi } from "./AccountsApi.ts"
import { AuthApi } from "./AuthApi.ts"
import { BacktestsApi } from "./BacktestsApi.ts"
import { BrokersApi } from "./BrokersApi.ts"
import { CandlesApi } from "./CandlesApi.ts"
import { DocumentsApi } from "./DocumentsApi.ts"
import { FxApi } from "./FxApi.ts"
import { InstrumentsApi } from "./InstrumentsApi.ts"
import { StrategiesApi } from "./StrategiesApi.ts"

// The API contract shared by the backend (implements it) and the frontend
// (derives a typed client from it). Keep server-only code out of this package.

export const Health = Schema.Struct({
  status: Schema.Literal("ok"),
  version: Schema.String,
  uptimeMs: Schema.Number,
  serverTime: Schema.Number
})
export type Health = typeof Health.Type

export class SystemApi extends HttpApiGroup.make("system", { topLevel: true }).add(
  HttpApiEndpoint.get("health", "/health", { success: Health })
) {}

export class TradingApi extends HttpApi.make("trading-api")
  .add(SystemApi)
  .add(AuthApi)
  .add(InstrumentsApi)
  .add(CandlesApi)
  .add(BrokersApi)
  .add(DocumentsApi)
  .add(FxApi)
  .add(AccountsApi)
  .add(StrategiesApi)
  .add(BacktestsApi)
  .prefix("/api")
  .annotateMerge(OpenApi.annotations({ title: "Trading API" }))
{}
